import React from 'react';
import Account from "../../../components/pages/form/Account/Account";

const AccountPage = () => {
    return <Account />
};

export default AccountPage;